import * as React from 'react';
import { mergeStyles } from '@cian/utils';
import { CheckboxSucess12 as IconSuccess } from '@cian/ui-kit/icons/12/checkbox_sucess';
import { InlineText2 } from '@cian/ui-kit/typography';

const styles = require('./Amenity.css');

interface IAmenity {
  children: React.ReactNode;
  className?: string;
}

export function Amenity({ children, className }: IAmenity) {
  return (
    <div {...mergeStyles(styles['root'], className)}>
      <IconSuccess /> <span className={styles['title']}><InlineText2>{children}</InlineText2></span>
    </div>
  );
}
